import type { RequiredDeep } from 'type-fest';
import type { APIUser } from 'Models/models';

export const noPermissionsV2: RequiredDeep<APIUser['permissions']> = {
    beneficiaries: {
        create: false,
        view: false,
    },
    cards: {
        manage: false,
        view: false,
    },
    company: {
        manage: false,
    },
    conversions: {
        create: false,
    },
    payments: {
        create: false,
        view: false,
    },
    users: {
        invite: false,
        manage: false,
    },
    approval: {
        manage: false,
    },
    payroll: {
        view: false,
        create: false,
    },
    billing: {
        manage: false,
    },
    bills: {
        view: false,
        manage: false,
    },
};
